<template>
  <transition-group
    name="drop-fade"
    appear
  >
    <slot
      name="content"
    />
  </transition-group>
</template>

<script>
export default {
  name: 'OwalTransitionGroupDropFade',
}
</script>

<style scoped>
.drop-fade-enter-active {
  animation-name: drop-fade-in;
  animation-duration: 300ms;
  animation-timing-function: ease-in;
}

.drop-fade-leave-active {
  animation-name: drop-fade-out;
  animation-duration: 300ms;
  animation-timing-function: ease-out;
}

@keyframes drop-fade-in {
  0% {
    opacity: 0;
    height: 0;
    border-width: 0;
    border-color: none;
  }
  100% {
    opacity: 1;
    height: initial;
    border-width: 1px;
    border-color: initial;
  }
}

@keyframes drop-fade-out {
  0% {
    opacity: 1;
    height: initial;
    border-color: initial;
    border-width: 1px;
  }
  100% {
    opacity: 0;
    height: 0;
    border-width: 0px;
    border-color: none;
  }
}
</style>
